import {FormActionButtons} from "@dvrt/graphql-widgets";
import AllocationTable, {AllocationTableProps} from "./AllocationTable";
import {ErrorWithContext} from "@/utils/ErrorHelper";
import {useAuth} from "@/context/AuthProvider";

type Props = {
    // Form submit function
    submit: () => Promise<void>;

    // Form reset function
    reset: () => void;

    // Form hasChanged function
    hasChanged: boolean;

    // Submitting state: firstColumn
    enabled: boolean;

    // Errors
    errors: Record<string, ErrorWithContext[]>;
} & AllocationTableProps;

const DomainAllocation = ({
    submit,
    reset,
    hasChanged,
    enabled,
    errors,
    update,
    label,
    labelForAllocation,
    allocations,
    canSeeSystemAllocation,
}: Props) => {
    const auth = useAuth();
    const hasEditPermission = auth.hasPermission("edit_domain_licence");

    return (
        <div style={{width: "fit-content"}}>
            <AllocationTable
                key={"allocation-table" + label.id}
                label={label}
                labelForAllocation={labelForAllocation}
                allocations={allocations}
                errors={errors}
                update={update}
                hasEditPermission={hasEditPermission}
                canSeeSystemAllocation={canSeeSystemAllocation}
            />
            {hasEditPermission && (
                <div style={{width: "fit-content", margin: "0 auto", marginTop: "2rem"}}>
                    <FormActionButtons
                        key={"form-action-buttons-" + label.id}
                        mainAction={submit}
                        secondaryAction={reset}
                        mainButtonEnabled={hasChanged && enabled}
                        secondaryButtonEnabled={hasChanged && enabled}
                    />
                </div>
            )}
        </div>
    );
};

export default DomainAllocation;
